import React from "react";
import "./add.css";

// Multi-Industry with icons
const industries = [
  { icon: "💻", name: "IT & ITES" },
  { icon: "💰", name: "Banking & BFSI" },
  { icon: "🏥", name: "Healthcare & Pharma" },
  { icon: "📡", name: "Telecom & Networking" },
  { icon: "🏭", name: "Manufacturing & Engineering" },
  { icon: "⛽", name: "Energy & Oil/Gas" },
  { icon: "🛒", name: "Retail & E-Commerce" },
  { icon: "✈️", name: "Hospitality & Travel" },
  { icon: "🎓", name: "Education & EdTech" },
  { icon: "🚛", name: "Logistics & Supply Chain" },
  { icon: "🎬", name: "Media & Entertainment" },
{ icon: "🏦", name: "Government & Public Sector" }


];

// Competitive Advantage Timeline
const advantages = [
  { icon: "✅", text: "Successfully placing 5000+ professionals annually" },
  { icon: "👥", text: "Dedicated team of 25 recruiters & 10 mobilization specialists" },
  { icon: "🔍", text: "Rigorous pre-screening and competency mapping" },
  { icon: "🌐", text: "Strong alliances with 550+ corporate partners PAN inida" },
  { icon: "🎓", text: "Campus-to-corporate transformation partnerships" },
  { icon: "🛠️", text: "Integrated skill development & interview readiness programs" },
  { icon: "📈", text: "Reduce attrition risk focusing on cultural fit & career aspirations" },
];

const AboutPage = () => {
  return (
    <div className="about-container">

      {/* Why Partner With Us */}
      <h2 className="section-title">Why Partner with Us?</h2>
      <div className="why-partner-grid">
        {[
          { icon: "🌍", title: "Global Reach", text: "Access top talent worldwide" },
          { icon: "💼", title: "Expertise", text: "40+ years of HR leadership" },
          { icon: "📊", title: "Data-Driven", text: "Smart hiring with analytics" },
          { icon: "🤝", title: "Trusted Partner", text: "Long-term client relationships" },
          { icon: "🚀", title: "Scalable Solutions", text: "Flexible hiring for every business size" },
{ icon: "🎯", title: "Customized Approach", text: "Tailored strategies for unique needs" }

        ].map((item, idx) => (
          <div className="mini-card gradient-mini-card" key={idx}>
            <div className="icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        ))}
      </div>

      {/* Multi-Industry Expertise - Icon Grid */}
      <h2 className="section-title">Multi-Industry Expertise</h2>
      <div className="industry-grid">
        {industries.map((item, idx) => (
          <div className="industry-card" key={idx}>
            <div className="industry-icon">{item.icon}</div>
            <p>{item.name}</p>
          </div>
        ))}
      </div>

      {/* Competitive Advantage - Timeline */}
      <h2 className="section-title">Our Competitive Advantage</h2>
      <div className="timeline">
        {advantages.map((item, idx) => (
          <div className="timeline-item" key={idx}>
            <div className="timeline-icon">{item.icon}</div>
            <div className="timeline-content">
              <span className="timeline-number">{idx + 1}</span>
              <p>{item.text}</p>
            </div>
          </div>
        ))}
      </div>

     
    </div>
  );
};

export default AboutPage;
